import { DestinationAddressConstants } from '../store/destinationAddress.constants'

export const destinationAddressSchemas = [
  {
    inputKey: DestinationAddressConstants.SET_LOCATION,
    isNumber: false,
    type: 'object',
    properties: {
      SET_LOCATION: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,100}$',
      },
    },
    additionalProperties: false,
    required: ['SET_LOCATION'],
    errorMessage: {
      properties: {
        SET_LOCATION: 'Must be alphanumeric with max length of 100',
      },
    },
  },
  {
    inputKey: DestinationAddressConstants.SET_ADDRESS_LINE1,
    isNumber: false,
    type: 'object',
    properties: {
      SET_ADDRESS: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,255}$',
      },
    },
    additionalProperties: false,
    required: ['SET_ADDRESS_LINE1'],
    errorMessage: {
      properties: {
        SET_ADDRESS_LINE1: 'Must be alphanumeric with max length of 255',
      },
    },
  },
  {
    inputKey: DestinationAddressConstants.SET_ADDRESS_LINE2,
    isNumber: false,
    type: 'object',
    properties: {
      SET_ADDRESS_LINE2: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,1000}$',
      },
    },
    additionalProperties: false,
    required: ['SET_ADDRESS_LINE2'],
    errorMessage: {
      properties: {
        SET_ADDRESS_LINE2: 'Must be alphanumeric with max length of 1000',
      },
    },
  },
  {
    inputKey: DestinationAddressConstants.SET_APT_SUITE_ROOM,
    isNumber: false,
    type: 'object',
    properties: {
      SET_APT_SUITE_ROOM: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,15}$',
      },
    },
    additionalProperties: false,
    required: ['SET_APT_SUITE_ROOM'],
    errorMessage: {
      properties: {
        SET_APT_SUITE_ROOM: 'Must be alphanumeric with max length of 15',
      },
    },
  },
  {
    inputKey: DestinationAddressConstants.SET_MILE_POST_MAJOR_ROADWAY,
    isNumber: false,
    type: 'object',
    properties: {
      SET_MILE_POST_MAJOR_ROADWAY: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,35}$',
      },
    },
    additionalProperties: false,
    required: ['SET_MILE_POST_MAJOR_ROADWAY'],
    errorMessage: {
      properties: {
        SET_MILE_POST_MAJOR_ROADWAY: 'Must be alphanumeric with max length of 35',
      },
    },
  },
  {
    inputKey: DestinationAddressConstants.SET_CROSS_STREET_DIRECTIONS,
    isNumber: false,
    type: 'object',
    properties: {
      SET_CROSS_STREET_DIRECTIONS: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,255}$',
      },
    },
    additionalProperties: false,
    required: ['SET_CROSS_STREET_DIRECTIONS'],
    errorMessage: {
      properties: {
        SET_CROSS_STREET_DIRECTIONS: 'Must be alphanumeric with max length of 255',
      },
    },
  },
  {
    inputKey: DestinationAddressConstants.SET_CITY,
    isNumber: false,
    type: 'object',
    properties: {
      SET_CITY: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,150}$',
      },
    },
    additionalProperties: false,
    required: ['SET_CITY'],
    errorMessage: {
      properties: {
        SET_CITY: 'Must be alphanumeric with max length of 150',
      },
    },
  },
  {
    inputKey: DestinationAddressConstants.SET_ZIP,
    isNumber: false,
    type: 'object',
    properties: {
      SET_ZIP: {
        type: 'string',
        pattern: '^([0-9][0-9][0-9][0-9][0-9]|[0-9][0-9][0-9][0-9][0-9]-[0-9][0-9][0-9][0-9])$',
      },
    },
    additionalProperties: false,
    required: ['SET_ZIP'],
    errorMessage: {
      properties: {
        SET_ZIP: 'Must be in the format: NNNNN or NNNNN-NNNN',
      },
    },
  },
  {
    inputKey: DestinationAddressConstants.SET_CENSUS_TRACT,
    isNumber: false,
    type: 'object',
    properties: {
      SET_CENSUS_TRACT: {
        type: 'string',
        pattern: '^[0-9]{11}$',
      },
    },
    additionalProperties: false,
    required: ['SET_CENSUS_TRACT'],
    errorMessage: {
      properties: {
        SET_CENSUS_TRACT: 'Must be an 11-digit number',
      },
    },
  },
  {
    inputKey: DestinationAddressConstants.SET_COUNTY,
    isNumber: false,
    type: 'object',
    properties: {
      SET_COUNTY: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,150}$',
      },
    },
    additionalProperties: false,
    required: ['SET_COUNTY'],
    errorMessage: {
      properties: {
        SET_COUNTY: 'Must be alphanumeric with max length of 150',
      },
    },
  },
  {
    inputKey: DestinationAddressConstants.SET_RECEIVING_RN,
    isNumber: false,
    type: 'object',
    properties: {
      SET_RECEIVING_RN: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,250}$',
      },
    },
    additionalProperties: false,
    required: ['SET_RECEIVING_RN'],
    errorMessage: {
      properties: {
        SET_RECEIVING_RN: 'Must be alphanumeric with max length of 250',
      },
    },
  },
  {
    inputKey: DestinationAddressConstants.SET_RECEIVING_MD,
    isNumber: false,
    type: 'object',
    properties: {
      SET_RECEIVING_MD: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,250}$',
      },
    },
    additionalProperties: false,
    required: ['SET_RECEIVING_MD'],
    errorMessage: {
      properties: {
        SET_RECEIVING_MD: 'Must be alphanumeric with max length of 250',
      },
    },
  },
  {
    inputKey: DestinationAddressConstants.SET_RECEIVING_USNG,
    isNumber: false,
    type: 'object',
    properties: {
      SET_RECEIVING_USNG: {
        type: 'string',
        pattern: '([1-9]|[1-5][0-9]|60)[C-HJ-NP-X][A-HJ-NP-Z][A-HJ-NP-V][0-9]{8}',
      },
    },
    additionalProperties: false,
    required: ['SET_RECEIVING_USNG'],
    errorMessage: {
      properties: {
        SET_RECEIVING_USNG: 'Must be in the format of USNG (e.g., 18SUJ2337106519).',
      },
    },
  },
  {
    inputKey: DestinationAddressConstants.SET_COMMENT,
    isNumber: false,
    type: 'object',
    properties: {
      SET_COMMENT: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,250}$',
      },
    },
    additionalProperties: false,
    required: ['SET_COMMENT'],
    errorMessage: {
      properties: {
        SET_COMMENT: 'Must be alphanumeric with max length of 250',
      },
    },
  },
]
